module.exports = __webpack_public_path__ + "img/visa-white.0b92a206.svg";